var rarity = {
  trait_type: "Dress",
  value: "VMorado",
};

export default rarity;
